var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pdl" },
    [
      !_vm.disabled
        ? _c(
            "el-row",
            { staticClass: "mb10", attrs: { type: "flex" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.openModal } },
                [_vm._v("添加商品")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.clearList } },
                [_vm._v("清空")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-table",
        {
          attrs: {
            border: "",
            "header-cell-class-name": "tableHeader",
            data: _vm.list,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "商品编码",
              fixed: "",
              width: "200px",
              prop: "productCode",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "商品名称",
              fixed: "",
              width: "200px",
              prop: "productName",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "规格", width: "100px", prop: "spec" },
          }),
          _c("el-table-column", {
            attrs: { label: "数量（盒/瓶）", width: "120px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入数量",
                        disabled: _vm.disabled,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.getNum(scope.row, scope.$index)
                        },
                      },
                      model: {
                        value: scope.row.num,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "num", $$v)
                        },
                        expression: "scope.row.num",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "商品单价（元）", width: "120px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { placeholder: "请输入商品单价", disabled: "" },
                      model: {
                        value: scope.row.productPrice,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "productPrice", $$v)
                        },
                        expression: "scope.row.productPrice",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "总金额（元）",
              "min-width": "130px",
              prop: "productTotalPrice",
            },
          }),
          _vm.disabled
            ? _c("el-table-column", {
                attrs: {
                  label: "销售区域",
                  "min-width": "400px",
                  prop: "saleArea",
                },
              })
            : _c("el-table-column", {
                attrs: { label: "销售区域", "min-width": "400px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-cascader", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.disabled,
                            options: _vm.areaOptions,
                            props: _vm.cascaderProps,
                            clearable: "",
                            "show-all-levels": true,
                            placeholder: "请选择销售区域",
                          },
                          on: { change: _vm.toFather },
                          model: {
                            value: scope.row.saleArea,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "saleArea", $$v)
                            },
                            expression: "scope.row.saleArea",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
          !_vm.disabled
            ? _c("el-table-column", {
                attrs: { label: "操作", width: "80px", fixed: "right" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "delIcon",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteItem(scope.$index)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1318343454
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }